"use strict";

var PropTypes = require("prop-types");

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");

class OrganizationContactTypeSelector extends React.Component {
	render() {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				thisArg={this}
				config={this.props.organizationContactTypeConfig}
				wizard={AccountStore.get("wizardOrganizationContactTypes")}
				wizardValuesKey="contactType"
				configKey="availableContactTypes"
				reactComponentName="OrganizationContactTypeSelector"
				selectClassName="organization-contact-type-selector"
				optionsClassName="organization-contact-type"
				selectNameAttribute="organizationContactType"
			/>
		);
	}
}

OrganizationContactTypeSelector.propTypes = {
	childClass: PropTypes.string,
	context: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	isDesignMode: PropTypes.bool,
	organizationContactTypeConfig: PropTypes.object,
	reactComponentCategory: PropTypes.string,
	required: PropTypes.bool,
	theme: PropTypes.string
};

module.exports = OrganizationContactTypeSelector;
